import React, { useState, useCallback } from "react";
import { AppBar, Box, Drawer, IconButton, Toolbar } from "@mui/material";
import { ErrorBoundary } from "react-error-boundary";
import { Menu } from "react-feather";
import { Outlet } from "react-router-dom";
import styled from "styled-components/macro";
import ErrorBoundaryUI from "../../components/ErrorBoundaryUI";
import UserProfile from "../../components/Header/UserProfile";
import NavDrawer from "./NavDrawer";

const DRAWERWIDTH = 250;

const Root = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
`;

const CustomAppBar = styled(AppBar)`
  background-color: white;
  box-shadow: none;
`;

const MainBox = styled(Box)`
  background-color: ${(props) => props.theme.palette.background.main};
`;

const CustomIconButton = styled(IconButton)`
  margin-left: 12ppx;

  svg {
    color: ${(props) => props.theme.palette.background.bw};
  }
`;

const CustomToolbar = styled(Toolbar)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${(props) => props.theme.palette.nav.toolbar};
`;

const StayRight = styled.div`
  margin-right: 8px;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  &.Avatar {
    margin-right: 8px;
  }
`;

const Dashboard = () => {
  const [open, setOpen] = useState(false);
  const handleDrawerToggle = useCallback(() => setOpen((p) => !p), []);

  return (
    <Root>
      <CustomAppBar
        position="fixed"
        style={{ zIndex: 1000 }}
        sx={{
          width: { md: `calc(100% - ${DRAWERWIDTH}px)` },
          ml: { md: `${DRAWERWIDTH}px` },
          zIndex: 1000,
        }}
      >
        <CustomToolbar>
          <CustomIconButton
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            edge="start"
            size="large"
            sx={{
              mr: 2,
              display: { md: "none" },
              ml: 2,
            }}
          >
            <Menu />
          </CustomIconButton>
          <StayRight>
            <UserProfile />
          </StayRight>
        </CustomToolbar>
      </CustomAppBar>
      <Box
        component="nav"
        sx={{ width: { md: DRAWERWIDTH }, flexShrink: { md: 0 } }}
      >
        <Drawer
          variant="temporary"
          open={open}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            zIndex: 1500,
            display: { xs: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: DRAWERWIDTH,
            },
          }}
        >
          <NavDrawer />
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
              width: DRAWERWIDTH,
            },
          }}
          open
        >
          <NavDrawer />
        </Drawer>
      </Box>
      <MainBox
        component="main"
        sx={{
          flexGrow: 1,
          p: 0,
          width: { md: `calc(100% - ${DRAWERWIDTH}px)` },
          marginTop: 16,
          position: "relative",
        }}
      >
        <ErrorBoundary fallback={<ErrorBoundaryUI />}>
          <Outlet />
        </ErrorBoundary>
      </MainBox>
    </Root>
  );
};

export default Dashboard;
